<mat-card class="chart-card">
  <mat-card-header>
    <mat-card-title>{{ 'analytics.registeredCandidatesDashboard' | transloco }}</mat-card-title>
    <mat-card-subtitle>{{ 'analytics.comprehensiveView' | transloco }}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <!-- SSR placeholder -->
    <div *ngIf="!isBrowser" class="ssr-placeholder">
      <p>{{ 'analytics.loadingDashboard' | transloco }}</p>
    </div>

    <!-- Render dashboard only in browser -->
    <ng-container *ngIf="isBrowser">
      <!-- Loading state -->
      <div *ngIf="loading" class="loading-overlay">
        <mat-spinner diameter="50"></mat-spinner>
        <p>{{ 'analytics.loadingAnalytics' | transloco }}</p>
      </div>

      <!-- Error state -->
      <div *ngIf="error && !loading" class="error-message">
        <p>{{ error }}</p>
      </div>

      <!-- Dashboard Grid -->
      <div *ngIf="!loading && !error" class="dashboard-grid">
        <!-- Time Series Chart - Full Width Top Row -->
        <div class="breakdown-section time-series-section">
          <div class="chart-header">
            <h3>{{ 'analytics.timeSeries' | transloco }}</h3>
            <p class="chart-subtitle">{{ 'analytics.registeredCandidatesOverTime' | transloco }}</p>
          </div>
          <div class="chart-container">
            <ngx-charts-line-chart
              *ngIf="timeSeriesData.length > 0"
              [scheme]="timeSeriesColorScheme"
              [results]="timeSeriesData"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [legendPosition]="legendPosition"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="'analytics.xAxisDate' | transloco"
              [yAxisLabel]="'analytics.yAxisCandidateCount' | transloco"
              [animations]="animations"
              [yAxisTickFormatting]="yAxisTickFormatting"
              (select)="onSelect($event)"></ngx-charts-line-chart>

            <div *ngIf="timeSeriesData.length === 0" class="no-data">
              <p>{{ 'analytics.noTimeSeriesData' | transloco }}</p>
            </div>
          </div>
        </div>

        <!-- Breakdown Charts - Flexible Layout -->
        <div class="breakdown-tables-container">
          <div class="breakdown-section">
            <div class="chart-header">
              <h3>{{ 'analytics.byCategory' | transloco }}</h3>
              <p class="chart-subtitle">{{ 'analytics.topNinePlusOthers' | transloco }}</p>
            </div>
            <div class="chart-container">
              <ngx-charts-bar-vertical
                *ngIf="categoryData.length > 0"
                [scheme]="categoryColorScheme"
                [results]="categoryData"
                [gradient]="gradient"
                [xAxis]="showXAxisBar"
                [yAxis]="showYAxisBar"
                [legend]="showLegendBar"
                [showXAxisLabel]="showXAxisLabelBar"
                [showYAxisLabel]="showYAxisLabelBar"
                [yAxisLabel]="'analytics.yAxisCount' | transloco"
                [animations]="animations"
                [yAxisTickFormatting]="yAxisTickFormatting"
                (select)="onSelect($event)"></ngx-charts-bar-vertical>

              <div *ngIf="categoryData.length === 0" class="no-data">
                <p>{{ 'analytics.noCategoryData' | transloco }}</p>
              </div>
            </div>
          </div>

          <div class="chart-section breakdown-section">
            <div class="chart-header">
              <h3>{{ 'analytics.byPosition' | transloco }}</h3>
              <p class="chart-subtitle">{{ 'analytics.topNinePlusOthers' | transloco }}</p>
            </div>
            <div class="chart-container">
              <ngx-charts-bar-vertical
                *ngIf="positionData.length > 0"
                [scheme]="positionColorScheme"
                [results]="positionData"
                [gradient]="gradient"
                [xAxis]="showXAxisBar"
                [yAxis]="showYAxisBar"
                [legend]="showLegendBar"
                [showXAxisLabel]="showXAxisLabelBar"
                [showYAxisLabel]="showYAxisLabelBar"
                [yAxisLabel]="'analytics.yAxisCount' | transloco"
                [animations]="animations"
                [yAxisTickFormatting]="yAxisTickFormatting"
                (select)="onSelect($event)"></ngx-charts-bar-vertical>

              <div *ngIf="positionData.length === 0" class="no-data">
                <p>{{ 'analytics.noPositionData' | transloco }}</p>
              </div>
            </div>
          </div>

          <div class="chart-section breakdown-section">
            <div class="chart-header">
              <h3>{{ 'analytics.byLocation' | transloco }}</h3>
              <p class="chart-subtitle">{{ 'analytics.topNinePlusOthers' | transloco }}</p>
            </div>
            <div class="chart-container">
              <ngx-charts-bar-vertical
                *ngIf="locationData.length > 0"
                [scheme]="locationColorScheme"
                [results]="locationData"
                [gradient]="gradient"
                [xAxis]="showXAxisBar"
                [yAxis]="showYAxisBar"
                [legend]="showLegendBar"
                [showXAxisLabel]="showXAxisLabelBar"
                [showYAxisLabel]="showYAxisLabelBar"
                [yAxisLabel]="'analytics.yAxisCount' | transloco"
                [animations]="animations"
                [yAxisTickFormatting]="yAxisTickFormatting"
                (select)="onSelect($event)"></ngx-charts-bar-vertical>

              <div *ngIf="locationData.length === 0" class="no-data">
                <p>{{ 'analytics.noLocationData' | transloco }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
